import { 
  REQUEST_ORDER_SUMMARY, 
  RECEIVE_ORDER_SUMMARY,
  FAIL_ORDER_SUMMARY, 
  MISSING_ITEMS_WARNING,
  CLEAR_ORDER_SUMMARY,
  CLEAR_MISSING_ITEMS_WARNING
} from "../actions/orderSummary";
import { 
  ADD_CART_ITEM, 
  ADD_CART_ITEMS,
  EDIT_CART_ITEM,
  REMOVE_CART_ITEM,
  CLEAR_CART, 
} from "../actions/cart";

export default function orderSummary(state = {
  loading: false,
  loaded: false,
  detail: null,
  missingItems: [],
  dirty: false,
}, action) {
  switch (action.type) {
    case CLEAR_ORDER_SUMMARY:
      return {
        ...state,
        loading: false,
        loaded: false,
        detail: null,
      };
    case REQUEST_ORDER_SUMMARY:
      return {
        ...state,
        loading: true,
        dirty: false,
      };
    case RECEIVE_ORDER_SUMMARY:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.payload.detail,
        lastUpdated: action.payload.receivedAt,
      };
    case MISSING_ITEMS_WARNING:
      return {
        ...state,
        missingItems: action.payload.missingItems
      }
    case FAIL_ORDER_SUMMARY:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_MISSING_ITEMS_WARNING: 
      return {
        ...state,
        missingItems: []
      }
    case ADD_CART_ITEM: 
    case ADD_CART_ITEMS:
    case EDIT_CART_ITEM:
    case REMOVE_CART_ITEM:
    case CLEAR_CART:
      return {
        ...state,
        dirty: true
      }
    default:
      return state;
  }
}